module.exports = __webpack_public_path__ + "img/27ff3e3.jpg";